import { createSignal, } from "solid-js";
import { signalExtender } from "../../../utils/signal.js";
function createBoundSignal(value, toBeBound, options) {
    return createBoundSignal.wrap(createSignal(value, options), toBeBound);
}
createBoundSignal.wrap = (signal, [value, onChange]) => {
    if (value)
        signal[0] = Object.assign(value, signal[0]);
    const [state, setState] = signalExtender(signal).extend(() => [{}, {}], ([state, setState]) => (setStateAction) => {
        const value = typeof setStateAction === "function"
            ? setStateAction(state())
            : setStateAction;
        onChange?.(value);
        return setState(value);
    });
    // Special handling for createHistory, think about generalizing this, maybe
    // setState.reinit
    // @ts-expect-error
    if ("history" in setState)
        setState.history([state()]);
    return [state, setState];
};
export default createBoundSignal;
